<script>
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import TabInformasiPeserta from "./components/informasi-peserta/tab-informasi-peserta.vue";
import TabJadwalAsesmen from "./components/jadwal-asesmen/tab-jadwal-asesmen.vue";
import TabPemilihanKompetensi from "./components/pemilihan-kompetensi/tab-pemilihan-kompetensi.vue";
import TabHistoryAsesmen from "./components/history-asesmen/tab-history-asesmen.vue";
import TabMasterBlueprint from "./components/master-blueprint/tab-master-blueprint.vue";
import { getStoredUserId, getStoredUser, restorePegawaiSession } from "@/helpers/sessionHelper";

export default {
  page: {
    title: "Dashboard Pegawai",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    TabInformasiPeserta,
    TabJadwalAsesmen,
    TabPemilihanKompetensi,
    TabHistoryAsesmen,
    TabMasterBlueprint,
  },
  data() {
    restorePegawaiSession();
    const storedUser = getStoredUser();
    return {
      user_name:
        storedUser?.nama ||
        localStorage.session_name ||
        sessionStorage.session_name ||
        "",
      // urutan key ini harus sinkron dengan urutan <b-tab> di template,
      // dipakai untuk membuka tab tertentu lewat query ?tab=<key>
      tabKeys: [
        "informasi-peserta",
        "jadwal-asesmen",
        "pemilihan-kompetensi",
        "history-asesmen",
        "master-blueprint",
      ],
      activeTabIndex: 0,
    };
  },
  created() {
    restorePegawaiSession();
    getStoredUserId();
    const tabIndex = this.tabKeys.indexOf(this.$route.query.tab);
    if (tabIndex > -1) {
      this.activeTabIndex = tabIndex;
    }
  },
  computed: {
    isPegawai() {
      return (
        localStorage.getItem("user_pegawai") === "pegawai_internal" ||
        sessionStorage.getItem("user_pegawai") === "pegawai_internal"
      );
    },
  },
  watch: {
    // sinkronkan query ?tab= setiap kali tab utama diklik, supaya tab yang
    // aktif tetap sama walau halaman di-reload
    activeTabIndex(newIndex) {
      const tabKey = this.tabKeys[newIndex];
      if (this.$route.query.tab !== tabKey) {
        this.$router.replace({ query: { ...this.$route.query, tab: tabKey } });
      }
    },
  },
  methods: {
    hapusLocalStorage() {
      Swal.fire({
        icon: "question",
        title: "Anda yakin akan logout ?",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((response) => {
        if (response.isConfirmed) {
          this.logout();
        }
      });
    },
    async logout() {
      let nip_peserta = localStorage.nip_peserta ?? "";
      localStorage.removeItem("uniqueId");

      if (nip_peserta) {
        try {
          await axios({
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/logout-sso",
            data: {
              nip: nip_peserta,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          });
        } catch (e) {
          console.log(e);
        }
      }
      sessionStorage.removeItem("informed_consent_shown");
      localStorage.clear();
      sessionStorage.clear();

      window.location.href = "/login-pegawai";
    },
  },
};
</script>

<template>
  <div class="mym-navbar">
    <div class="mym-navbar-inner">
      <div class="mym-navbar-brand">
        <div class="mym-navbar-logo">
          <img src="/logo_pln.png" alt="Logo PLN" style="height: 40px; object-fit: contain;" />
        </div>

        <div class="mym-navbar-text">
          <div class="mym-navbar-title">Dashboard Pegawai</div>
          <div class="mym-navbar-subtitle">Unit Pelaksana Sertifikasi</div>
        </div>
      </div>

      <div class="mym-navbar-action">
        <a href="javascript:void(0)" @click="hapusLocalStorage()">
          <i class="fas fa-sign-out-alt me-1"></i>
          Keluar
        </a>
      </div>
    </div>
  </div>

  <div class="mym-main-area">
    <div class="mym-content-panel mb-4">
      <div class="mym-section-body">
        <b-tabs
          v-model="activeTabIndex"
          class="mym-tab"
          content-class="mym-tab-content"
        >
          <b-tab title="Informasi Peserta">
            <TabInformasiPeserta />
          </b-tab>

          <b-tab title="Jadwal Asesmen">
            <TabJadwalAsesmen />
          </b-tab>

          <b-tab title="Pemilihan Kompetensi">
            <TabPemilihanKompetensi />
          </b-tab>

          <b-tab title="History Asesmen">
            <TabHistoryAsesmen />
          </b-tab>

          <b-tab title="Master Blueprint">
            <TabMasterBlueprint />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
